module.exports = __webpack_public_path__ + "static/media/closeBtn.1b15d1dc.svg";